module.exports = __webpack_public_path__ + "static/img/bannner.00bb520.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon/bannner.png
// module id = SgTe
// module chunks = 1